export default {
  code: 'de',
  meta: {
    title: 'Nanovitsa (Нановица), Bulgarien – Dorfführer zu Tatul, Momtschilgrad & Kardschali',
    description:
      'Führer zu Nanovitsa (Нановица), einem Dorf in der Gemeinde Momtschilgrad, Oblast Kardschali, Bulgarien: Fakten, Geschichte, Fotos, eine interaktive Karte und die Sehenswürdigkeiten der Umgebung – das Orpheus-Heiligtum von Tatul, Momtschilgrad, Kardschali, Perperikon und mehr.',
    keywords:
      'Nanovitsa, Нановица, Nanovitsa Bulgarien, Tatul, Orpheus-Heiligtum, Momtschilgrad, Kardschali, Kırcaali, Perperikon, Ostrhodopen, bulgarisches Dorf',
    ogTitle: 'Nanovitsa (Нановица) – Dorfführer zu Tatul, Momtschilgrad & Kardschali',
    ogDescription:
      'Fakten, Geschichte, Fotos und eine interaktive Karte von Nanovitsa und den Sehenswürdigkeiten der Umgebung in den Ostrhodopen im Süden Bulgariens.',
    twitterTitle: 'Nanovitsa (Нановица) – Dorfführer, Bulgarien',
    twitterDescription:
      'Fakten, Geschichte, Fotos und eine interaktive Karte von Nanovitsa und den Sehenswürdigkeiten der Umgebung in den Ostrhodopen.',
    schemaPlaceDescription:
      'Dorf in der Gemeinde Momtschilgrad, Oblast Kardschali, in den Ostrhodopen im Süden Bulgariens, nahe dem thrakischen Heiligtum von Tatul.',
    schemaTatulName: 'Tatul – thrakisches Orpheus-Heiligtum',
    schemaTatulDescription:
      'Thrakisches Heiligtum mit Siedlungsspuren ab etwa 4000 v. Chr., das mit dem Orpheus-Kult in Verbindung gebracht wird, beim Dorf Tatul in der Gemeinde Momtschilgrad, Bulgarien.',
  },
  nav: {
    overview: 'Überblick',
    explore: 'Erkunden',
    history: 'Geschichte',
    places: 'Orte',
    map: 'Karte',
    gallery: 'Galerie',
    news: 'Neuigkeiten',
  },
  hero: {
    eyebrow: 'Oblast Kardschali · Bulgarien',
    lead: 'Ein Dorf in den Ostrhodopen im Süden Bulgariens – und ein Führer zu seinen Nachbarn: dem thrakischen Heiligtum von Tatul, der Stadt Momtschilgrad und der Provinzhauptstadt Kardschali.',
    exploreBtn: 'Die Umgebung erkunden',
    mapBtn: 'Zur Karte',
    stats: { elevation: 'Höhe', population: 'Einwohner (2021)', area: 'Fläche', postal: 'Postleitzahl' },
  },
  overview: {
    kicker: '01 · Überblick',
    title: 'Ein Bergdorf in den Ostrhodopen',
    paragraphs: [
      'Nanovitsa (Нановица) ist ein Dorf in der Gemeinde Momtschilgrad, im Oblast Kardschali – dem südlichsten Verwaltungsbezirk Bulgariens, der an Griechenland grenzt.',
      'Die Ostrhodopen um das Dorf herum sind eine Landschaft aus sanften vulkanischen Hügeln, alten thrakischen Heiligtümern und gemischt bulgarisch-türkischen Gemeinden. Bei der Volkszählung 2011 bezeichneten sich 66,2 Prozent der Bevölkerung des Oblasts als Türken und 30,2 Prozent als Bulgaren. Die Region ist zudem ein Rückzugsort für Wildtiere: Fast jede europäische Greifvogelart lebt in den Ostrhodopen, darunter die seltenen Mönchs- und Schmutzgeier.',
      'Nanovitsa selbst ist klein – 456 Einwohner im Jahr 2021 –, liegt aber in einer bemerkenswerten Nachbarschaft. Das thrakische Heiligtum von Tatul liegt im nächsten Dorf, die Stadt Momtschilgrad ist das örtliche Verwaltungszentrum, und die Stadt Kardschali, die Provinzhauptstadt, ist das Tor zu Perperikon und den Stauseen der Arda.',
    ],
    note: 'Nicht zu verwechseln mit einem gleichnamigen Dorf im Oblast Lowetsch, das am 24. Februar 2007 als Siedlung aufgelöst wurde.',
    panelTitle: 'Von Nanovitsa aus',
    panelNote: 'Luftlinie und Richtung, keine Fahrstrecke.',
  },
  explore: {
    kicker: '02 · Erkunden',
    title: 'Vier Orte, eine Landschaft',
    lead: 'Wechseln Sie zwischen dem Dorf und seinen drei nächstgelegenen Bezugspunkten.',
    areas: [
      {
        id: 'nanovitsa',
        label: 'Nanovitsa',
        kicker: 'Das Dorf',
        title: 'Nanovitsa (Нановица)',
        lead: 'Ein kleines Bergdorf mit etwa 450 Einwohnern in den Ostrhodopen, mit eigenem Ortsbürgermeisteramt innerhalb der Gemeinde Momtschilgrad.',
        paragraphs: [
          'Nanovitsa liegt auf etwa 308 Metern über dem Meeresspiegel und erstreckt sich über rund 5,2 Quadratkilometer. Bei der Volkszählung 2021 hatte es 456 Einwohner. Die Ortsschilder am Dorfeingang sind in kyrillischer und lateinischer Schrift beschriftet, die Postleitzahl lautet 6830.',
          'Das Gebiet stand bis zum 30. Mai 1913 unter osmanischer Herrschaft; am 10. August 1913, nach den Balkankriegen, kam Nanovitsa unter bulgarische Verwaltung. Heute ist es ein Kmetstwo – ein Dorfbürgermeisteramt – innerhalb der Gemeinde Momtschilgrad.',
          'Das Dorf liegt inmitten der Nachbarorte Neofit Boswelievo, Lale und Dschelepsko, die alle an der Ausfallstraße ausgeschildert sind. Die umliegende Landschaft bietet einen Jagdstützpunkt und einen Stausee zum Angeln, und das thrakische Heiligtum von Tatul liegt nur eine kurze Strecke entfernt.',
        ],
        note: 'Nicht zu verwechseln mit einem gleichnamigen Dorf im Oblast Lowetsch, das am 24. Februar 2007 als Siedlung aufgelöst wurde.',
        facts: [
          ['Oblast', 'Kardschali'],
          ['Gemeinde', 'Momtschilgrad'],
          ['Höhe', '308 m'],
          ['Fläche', '5,2 km²'],
          ['Einwohner', '456 (2021)'],
          ['Postleitzahl', '6830'],
        ],
      },
      {
        id: 'tatul',
        label: 'Tatul',
        kicker: 'Thrakisches Heiligtum',
        title: 'Tatul und das Orpheus-Heiligtum',
        lead: 'Ein Dorf aus Steinhäusern neben einer der bedeutendsten antiken Stätten der Ostrhodopen.',
        paragraphs: [
          'Tatul ist ein Dorf in der Gemeinde Momtschilgrad, auf 319 Metern über dem Meeresspiegel. Sein Name stammt vom bulgarischen Ausdruck für den Stechapfel (Datura stramonium); die meisten Häuser sind aus gut behauenen Steinblöcken gebaut. Im Jahr 2005 hatte es 189 Einwohner.',
          'Über dem Dorf erhebt sich ein antikes thrakisches Heiligtum. Siedlungsspuren reichen bis etwa 4000 v. Chr. zurück, und das Heiligtum war vom 19. bis 18. Jahrhundert v. Chr. ununterbrochen in Gebrauch. Archäologen fanden aus dieser Zeit rund 30 Tonaltäre, ein eisenzeitliches Idol in Form einer nackten männlichen Figur sowie einen Steinsarkophag, der einem bedeutenden thrakischen Herrscher gehörte.',
          'Zwischen dem 4. und 1. Jahrhundert v. Chr. wurde eine Steinmauer um den Hügel errichtet, kurz darauf folgten ein Tempel und ein Mausoleum. Im 2. bis 3. Jahrhundert n. Chr. kamen weitere Gebäude hinzu. Im späten 4. oder frühen 5. Jahrhundert wurde die Anlage in einen christlichen Herrschaftssitz mit Wehrturm umgewandelt; Erdbeben beschädigten sie im 12. Jahrhundert v. Chr. und im 14. Jahrhundert n. Chr.',
          'Der leitende Archäologe Nikolay Ovcharov deutet die Anlage als Heiligtum und Grabstätte eines einflussreichen thrakischen Herrschers, der nach seinem Tod vergöttlicht wurde, und bringt sie mit dem Orpheus-Kult in Verbindung. Die Stätte wird mit neuer Infrastruktur touristisch erschlossen, und vom Dorf aus führt ein Wanderweg zum Versteinerten Wald.',
        ],
        facts: [
          ['Höhe', '319 m'],
          ['Koordinaten', '41°33′13″N 25°32′28″O'],
          ['Einwohner', '189 (2005)'],
          ['Von Nanovitsa', null],
          ['Früheste Besiedlung', 'ca. 4000 v. Chr.'],
          ['Heiligtum in Gebrauch', 'ab dem 19.–18. Jh. v. Chr.'],
        ],
      },
      {
        id: 'momchilgrad',
        label: 'Momtschilgrad',
        kicker: 'Die nächste Stadt',
        title: 'Momtschilgrad',
        lead: 'Eine Stadt mit rund 7.800 Einwohnern und Verwaltungssitz für Nanovitsa, mit türkischer Bevölkerungsmehrheit und langer osmanischer Vergangenheit.',
        paragraphs: [
          'Momtschilgrad liegt auf 452 Metern über dem Meeresspiegel in den Ostrhodopen. Bei der Volkszählung 2011 hatte die Stadt 7.831 Einwohner und ist die größte bulgarische Siedlung mit türkischer Bevölkerungsmehrheit, die rund 75 Prozent ausmacht.',
          'Bis 1934 hieß die Stadt Mastanli (Мастанли); die türkische Bevölkerung nennt sie noch heute Mestanlı. Nach dem Ersten Balkankrieg kam sie zu Bulgarien und wurde nach Momtschil, einer historischen Gestalt, umbenannt. Ihre historische Moschee mit zwei Minaretten wird seit rund 300 Jahren genutzt.',
          'Das 1969 in der Momtschil-Woiwoda-Straße 2 gegründete Museum von Momtschilgrad war das erste seiner Art im Oblast Kardschali und zeigt heute etwa 1.200 archäologische, volkskundliche und naturkundliche Exponate. Momtschilgrad ist zudem Geburtsort des Schwimmers Petar Stoytschew, der bis 2012 den Rekord für die schnellste Durchquerung des Ärmelkanals hielt, sowie des Gewichthebers Naim Süleymanoğlu (1967–2017).',
          'Die Gemeinde Momtschilgrad erstreckt sich über 358,12 Quadratkilometer und umfasst neben der Stadt 54 Dörfer, darunter Nanovitsa. Sie hatte 2011 insgesamt 16.263 Einwohner.',
        ],
        facts: [
          ['Höhe', '452 m'],
          ['Einwohner', '7.831 (2011)'],
          ['Früherer Name', 'Mastanli, bis 1934'],
          ['Von Nanovitsa', null],
          ['Gemeinde', '358,12 km², 55 Siedlungen'],
          ['Postleitzahl', '6800'],
        ],
      },
      {
        id: 'kardzhali',
        label: 'Kardschali',
        kicker: 'Die Provinzhauptstadt',
        title: 'Kardschali (Kırcaali)',
        lead: 'Die größte Stadt der Ostrhodopen und Verwaltungssitz des südlichsten bulgarischen Verwaltungsbezirks.',
        paragraphs: [
          'Kardschali liegt an beiden Ufern der Arda auf 275 Metern über dem Meeresspiegel, rund 260 Kilometer südöstlich von Sofia. Die Stadt hatte 2011 44.071 und 2021 40.659 Einwohner; die größere Gemeinde mit 117 Dörfern zählte 2011 67.846 Einwohner.',
          'Der Name geht auf „Kırca Ali“ zurück, einen türkischen Räuberhauptmann des 18. Jahrhunderts – daher der türkische Name Kırcaali. Die osmanische Herrschaft endete am 21. Oktober 1912, als der bulgarische General Wassil Delow die Stadt im Ersten Balkankrieg befreite.',
          'Kardschali war einst ein Zentrum der Tabakverarbeitung; heute stützt sich die Wirtschaft vor allem auf Handel und Dienstleistungen, während die Landwirtschaft einen wachsenden Anteil der Beschäftigten stellt. Zu den bekanntesten Sehenswürdigkeiten zählen das Regionale Geschichtsmuseum, die Stauseen Kardschali und Studen Kladenez sowie die antike Felsenstadt Perperikon, etwa 15 Kilometer nordöstlich. Das Klima ist mediterran mit heißen Sommern, mit einem Rekordwert von 43,2 °C.',
          'Der Oblast Kardschali erstreckt sich über 3.209,1 Quadratkilometer und grenzt an Griechenland. Er umfasst sieben Gemeinden – Ardino, Tschernootschene, Dschebel, Kardschali, Kirkowo, Krumowgrad und Momtschilgrad – und hatte 2021 141.177 Einwohner. 1999 wurde er als eigenständiger Verwaltungsbezirk wiederhergestellt, nachdem er seit 1987 zum Oblast Haskowo gehört hatte.',
        ],
        facts: [
          ['Höhe', '275 m'],
          ['Einwohner (Stadt)', '40.659 (2021)'],
          ['Fläche (Oblast)', '3.209,1 km²'],
          ['Von Nanovitsa', null],
          ['Fluss', 'Arda'],
          ['Gemeinden', '7 im Oblast'],
        ],
      },
    ],
  },
  numbers: {
    title: 'Die Region in Zahlen',
    cards: [
      {
        id: 'nanovitsa',
        name: 'Nanovitsa',
        role: 'Dorf',
        value: 456,
        caption: 'Einwohner, 2021',
        rows: [
          ['Höhe', '308 m'],
          ['Fläche', '5,2 km²'],
        ],
      },
      {
        id: 'momchilgrad',
        name: 'Momtschilgrad',
        role: 'Stadt und Gemeindesitz',
        value: 7831,
        caption: 'Einwohner, 2011',
        rows: [
          ['Höhe', '452 m'],
          ['Gemeinde', '16.263 Einwohner'],
        ],
      },
      {
        id: 'kardzhali',
        name: 'Kardschali',
        role: 'Provinzhauptstadt',
        value: 40659,
        caption: 'Einwohner, 2021',
        rows: [
          ['Höhe', '275 m'],
          ['Gemeinde', '67.846 Einwohner (2011)'],
        ],
      },
      {
        id: 'kardzhali-province',
        name: 'Oblast Kardschali',
        role: 'Südlichster Verwaltungsbezirk Bulgariens',
        value: 141177,
        caption: 'Einwohner, 2021',
        rows: [
          ['Fläche', '3.209,1 km²'],
          ['Gemeinden', '7'],
        ],
      },
    ],
  },
  timeline: {
    kicker: '03 · Geschichte',
    title: 'Siebentausend Jahre in den Hügeln',
    lead: 'Von den ersten Siedlern auf den Felsenhügeln bis zur modernen Volkszählung – nach Ort filtern, um einem Faden zu folgen.',
    filters: [
      { id: 'all', label: 'Alles' },
      { id: 'tatul', label: 'Tatul' },
      { id: 'perperikon', label: 'Perperikon' },
      { id: 'nanovitsa', label: 'Nanovitsa' },
      { id: 'momchilgrad', label: 'Momtschilgrad' },
      { id: 'kardzhali', label: 'Kardschali' },
    ],
    items: [
      { id: 'perperikon-first-activity', when: 'ca. 5000 v. Chr.', title: 'Erste menschliche Besiedlung von Perperikon', text: 'Spuren von Menschen auf dem Felsenhügel nordöstlich von Kardschali reichen bis etwa 5000 v. Chr. zurück.' },
      { id: 'tatul-earliest-settlement', when: 'ca. 4000 v. Chr.', title: 'Früheste Besiedlung von Tatul', text: 'Die ältesten Siedlungsspuren auf dem Hügel über dem Dorf Tatul.' },
      { id: 'tatul-sanctuary-in-use', when: '19.–18. Jh. v. Chr.', title: 'Das Heiligtum ist in Gebrauch', text: 'Aus dieser Zeit wurden am Heiligtum rund 30 Tonaltäre gefunden; es bleibt jahrhundertelang in Gebrauch.' },
      { id: 'perperikon-medokos', when: '424 v. Chr.', title: 'Medokos ruft sich zum König aus', text: 'Nach dem Tod des Sitalkes ruft sich Medokos in Perperikon zum thrakischen König aus, wird aber später gestürzt.' },
      { id: 'tatul-wall', when: '4.–1. Jh. v. Chr.', title: 'Eine Mauer umschließt den Heiligtumshügel', text: 'Um den Hügel wird eine Steinmauer errichtet, kurz darauf folgen ein Tempel und ein Mausoleum.' },
      { id: 'tatul-new-buildings', when: '2.–3. Jh. n. Chr.', title: 'Neue Bauten in Tatul', text: 'In römischer Zeit werden weitere Gebäude der Heiligtumsanlage hinzugefügt.' },
      { id: 'tatul-christian-period', when: 'Spätes 4./frühes 5. Jh. n. Chr.', title: 'Die christliche Periode', text: 'Das Heiligtum von Tatul wird zu einem christlichen Herrschaftssitz mit Wehrturm umgebaut; auch in Perperikon treten christliche Elemente auf.' },
      { id: 'perperikon-fortress-ends', when: '14. Jahrhundert', title: 'Das Ende der mittelalterlichen Festung', text: 'Bis zu diesem Zeitpunkt diente Perperikon als mittelalterliche Festung. Ein Erdbeben beschädigt im 14. Jahrhundert auch das Heiligtum von Tatul.' },
      { id: 'ali-bey-house', when: '1851', title: 'Das Haus des Ali Bey', text: 'Im Dorf Manchevo, im heutigen Gemeindegebiet von Momtschilgrad, wird ein Haus errichtet.' },
      { id: 'kardzhali-liberated', when: '21. Oktober 1912', title: 'Kardschali wird befreit', text: 'Die osmanische Herrschaft in Kardschali endet, als General Wassil Delow die Stadt im Ersten Balkankrieg befreit.' },
      { id: 'nanovitsa-joins-bulgaria', when: '30. Mai – 10. August 1913', title: 'Nanovitsa kommt zu Bulgarien', text: 'Die osmanische Kontrolle über das Gebiet endet am 30. Mai. Am 10. August 1913 kommt Nanovitsa unter bulgarische Verwaltung.' },
      { id: 'momchilgrad-renamed', when: '1934', title: 'Aus Mastanli wird Momtschilgrad', text: 'Die Stadt wird offiziell in Momtschilgrad umbenannt, nach Momtschil, anstelle ihres osmanischen Namens Mastanli.' },
      { id: 'kardzhali-reservoir-built', when: '1957–1963', title: 'Der Stausee Kardschali entsteht', text: 'Der Bau des Staudamms an der Arda beginnt 1957, der Stausee wird 1963 eröffnet; die Arbeiten dauern bis 1976 an.' },
      { id: 'momchilgrad-museum-opens', when: '1969', title: 'Das Museum von Momtschilgrad öffnet', text: 'Das erste Museum seiner Art im Oblast Kardschali wird gegründet und zeigt heute rund 1.200 Exponate.' },
      { id: 'stone-mushrooms-protected', when: '13. Mai 1974', title: 'Die Steinpilze werden unter Schutz gestellt', text: 'Die Felsformationen bei Beli Plast werden zum Naturdenkmal erklärt.' },
      { id: 'kardzhali-province-restored', when: '1999', title: 'Der Oblast Kardschali wird wiederhergestellt', text: 'Nach zwölf Jahren als Teil des Oblasts Haskowo wird der Verwaltungsbezirk neu gebildet.' },
      { id: 'perperikon-excavations-begin', when: '2000', title: 'Systematische Ausgrabungen beginnen', text: 'Der Archäologe Nikolay Ovcharov beginnt die systematische Ausgrabung von Perperikon, die bis heute andauert.' },
      { id: 'nanovitsa-census-2021', when: '2021', title: 'Volkszählung: 456 Einwohner', text: 'Die Volkszählung 2021 verzeichnet 456 Einwohner in Nanovitsa.' },
    ],
  },
  places: {
    kicker: '04 · Orte',
    title: 'Sehenswertes rund um Nanovitsa',
    lead: 'Antike Städte, Naturdenkmäler und historische Bauten in Reichweite des Dorfes. Die Entfernungen sind Luftlinie ab Nanovitsa.',
    categories: {
      village: 'Dorf',
      town: 'Stadt',
      ancient: 'Antike Stätte',
      nature: 'Natur',
      water: 'Gewässer',
      heritage: 'Kulturerbe',
    },
    filters: [
      { id: 'all', label: 'Alle Orte' },
      { id: 'ancient', label: 'Antike Stätten' },
      { id: 'nature', label: 'Natur' },
      { id: 'water', label: 'Gewässer' },
      { id: 'heritage', label: 'Kulturerbe' },
      { id: 'town', label: 'Städte' },
    ],
    items: [
      {
        id: 'nanovitsa',
        name: 'Nanovitsa',
        summary: 'Das Dorf, um das es auf dieser Seite geht, in den Hügeln der Gemeinde Momtschilgrad.',
        details: [],
      },
      {
        id: 'tatul',
        name: 'Tatul und das Orpheus-Heiligtum',
        shortName: 'Tatul',
        summary: 'Ein Nachbardorf mit einem der bekanntesten thrakischen Heiligtümer der Ostrhodopen, das mit dem Orpheus-Kult in Verbindung gebracht wird.',
        details: [
          ['Höhe', '319 m'],
          ['Früheste Besiedlung', 'ca. 4000 v. Chr.'],
          ['Heiligtum in Gebrauch', 'ab dem 19.–18. Jh. v. Chr.'],
          ['Christliche Periode', 'spätes 4./frühes 5. Jh. n. Chr.'],
        ],
      },
      {
        id: 'perperikon',
        name: 'Perperikon',
        summary: 'Eine in den Fels gehauene antike Stadt auf einem 470 m hohen Hügel, beschrieben als die größte Megalithanlage auf dem Balkan.',
        details: [
          ['Lage', 'etwa 15 km nordöstlich von Kardschali'],
          ['Besiedlung', 'seit etwa 5000 v. Chr.'],
          ['Festungsmauern', 'bis zu 2,8 m dick'],
          ['Ausgrabungen', 'systematisch seit 2000, geleitet von Nikolay Ovcharov'],
          ['Spätere Nutzung', 'bis ins 14. Jahrhundert als mittelalterliche Festung'],
        ],
      },
      {
        id: 'petrified-forest',
        name: 'Versteinerter Wald',
        summary: 'Ein geschütztes Naturdenkmal im Tal Gabaz Dere beim Dorf Raven, mit rund 30 Millionen Jahre alten versteinerten Bäumen.',
        details: [
          ['Alter', 'rund 30 Millionen Jahre'],
          ['Entstehung', 'ein alter Wald, der bei einem Vulkanausbruch teilweise verschüttet wurde'],
          ['Besonderheit', 'Berichten zufolge der einzige derartige Wald, in dem die Stämme noch aufrecht stehen'],
          ['Ausgangspunkte', 'Raven, Tatul und Gurgulitsa'],
        ],
      },
      {
        id: 'stone-mushrooms',
        name: 'Die Steinpilze',
        summary: 'Pilzförmige Felsformationen östlich von Beli Plast, an der Straße zwischen Kardschali und Haskowo.',
        details: [
          ['Größe', 'Stiele und Kappen bis zu 2,5 m'],
          ['Gestein', 'rhyolithischer Vulkantuff aus untermeerischem Vulkanismus im Paläozän'],
          ['Farben', 'rosa Stiele (Clinoptilolith) und grüne Kappen (Seladonit)'],
          ['Schutzstatus', 'Naturdenkmal seit 13. Mai 1974, auf 3 Hektar'],
        ],
      },
      {
        id: 'kardzhali-reservoir',
        name: 'Stausee Kardschali',
        summary: 'Ein großer Stausee an der Arda, beliebt zum Angeln und für Freizeitaktivitäten, mit einer 103,5 m hohen Bogengewichtsstaumauer.',
        details: [
          ['Fläche', '16,07 km²'],
          ['Volumen', '497,2 Mio. m³ – der zweitgrößte Bulgariens'],
          ['Staumauer', '103,5 m hoch, 402,89 m lang; die einzige Bogengewichtsmauer Bulgariens'],
          ['Leistung', '122 MW aus vier Turbinen'],
          ['Bauzeit', 'begonnen 1957, eröffnet 1963, Arbeiten bis 1976'],
          ['Sehenswürdigkeiten', 'die Flussschleife Sawoja und die Ruinen der Festung Patmos'],
        ],
      },
      {
        id: 'rock-niches',
        name: 'Felsnischen von Neofit Boswelievo und Lale',
        summary: 'Eine Kultstätte mit Felsnischen zwischen den Dörfern Neofit Boswelievo und Lale; zwei der Nischen haben ungewöhnliche akustische Eigenschaften.',
        details: [
          ['Nischen', '11, auf zwei Ebenen'],
          ['Akustik', 'zwei Nischen erzeugen ein auffälliges Echo bei Geräuschen davor'],
          ['Lage', 'rund 2 km von Neofit Boswelievo, bei Lale'],
        ],
      },
      {
        id: 'ali-bey-house',
        name: 'Haus des Ali Bey, Mantschevo',
        summary: 'Ein 1851 im Dorf Mantschevo errichtetes historisches Haus, ein erhaltenes Beispiel der Architektur des 19. Jahrhunderts der Region.',
        details: [
          ['Erbaut', '1851'],
          ['Dorf', 'Mantschevo, auf 647 m Höhe'],
        ],
      },
      {
        id: 'borovets',
        name: 'Naturschutzgebiet Borowez',
        summary: 'Ein geschütztes Waldgebiet bei Raven, das Kiefern-, Eichen-, Wildbirnen- und Wacholderbestände bewahrt.',
        details: [['Schützt', 'Kiefern-, Eichen-, Wildbirnen- und Wacholderwald']],
      },
      {
        id: 'momchilgrad',
        name: 'Momtschilgrad',
        summary: 'Die nächstgelegene Stadt und Sitz der Gemeinde, mit einem 1969 gegründeten Museum und einer Moschee mit zwei Minaretten.',
        details: [
          ['Höhe', '452 m'],
          ['Einwohner', '7.831 (2011)'],
          ['Museum', 'rund 1.200 archäologische, volkskundliche und naturkundliche Exponate'],
        ],
      },
      {
        id: 'kardzhali',
        name: 'Kardschali',
        summary: 'Die Hauptstadt des Oblasts, an beiden Ufern der Arda, mit einem regionalen Geschichtsmuseum. Perperikon liegt etwa 15 km nordöstlich.',
        details: [
          ['Höhe', '275 m'],
          ['Einwohner', '40.659 (2021)'],
          ['Entfernung von Sofia', 'rund 260 km südöstlich'],
        ],
      },
    ],
  },
  map: {
    kicker: '06 · Karte',
    title: 'Orientierung in der Umgebung',
    lead: 'Wählen Sie einen Ort aus der Liste oder tippen Sie auf eine Markierung, um die Entfernung ab Nanovitsa zu sehen.',
    ariaMap: 'Interaktive Karte von Nanovitsa und den umliegenden Orten',
    youAreHere: 'Sie sind hier',
    showAll: 'Alle Orte anzeigen',
    hint: 'Nur Orte mit veröffentlichten Koordinaten sind markiert. Kartendaten © OpenStreetMap-Mitwirkende.',
    distanceSuffix: 'von Nanovitsa',
  },
  gallery: {
    kicker: '07 · Galerie',
    title: 'Die Landschaft in Bildern',
    lead: 'Auf ein Foto klicken, um es zu vergrößern; mit den Pfeiltasten durch die Bilder blättern.',
    filters: [
      { id: 'all', label: 'Alle Fotos' },
      { id: 'nanovitsa', label: 'Nanovitsa' },
      { id: 'tatul', label: 'Tatul' },
      { id: 'momchilgrad', label: 'Momtschilgrad' },
      { id: 'kardzhali', label: 'Kardschali' },
      { id: 'region', label: 'Rund um die Region' },
    ],
  },
  photos: {
    'village-minaret': { alt: 'Ein weißes Minarett ragt über Bäume und ein rotes Ziegeldach hinaus, im Hintergrund Hügel', caption: 'Das Minarett und rote Ziegeldächer, dahinter die Rhodopenhügel' },
    'village-sign': { alt: 'Ortsschild mit der Aufschrift Нановица / Nanovitsa am Dorfrand', caption: 'Das Ortsschild in kyrillischer und lateinischer Schrift' },
    'village-view': { alt: 'Häuser am Rand von Nanovitsa, im Blick über einen trockenen Hang', caption: 'Häuser am Dorfrand' },
    'village-road': { alt: 'Eine Landstraße mit einer Steinbrüstung und Häusern an einem Hang', caption: 'Die Straße am Dorfrand' },
    'village-signpost': { alt: 'Blaue Wegweiser nach Neofit Boswelievo, Lale und Dschelepsko', caption: 'Wegweiser zu den Nachbardörfern Neofit Boswelievo, Lale und Dschelepsko' },
    'tatul-panorama': { alt: 'Blick über die bewaldeten Hügel der Ostrhodopen vom Heiligtum von Tatul aus', caption: 'Blick über die Ostrhodopen vom Heiligtum von Tatul aus' },
    'tatul-niche': { alt: 'Eine große in den Fels gehauene Nische in Tatul', caption: 'Eine in den Fels gehauene Nische' },
    'tatul-summit': { alt: 'Der Felsgipfel von Tatul mit bewaldeten Hügeln in der Ferne', caption: 'Der Felsgipfel des Heiligtums' },
    'tatul-rock-niche': { alt: 'Eine in verwittertem Fels gehauene Nische in Tatul', caption: 'Eine Felsnische im Heiligtum von Tatul' },
    'tatul-sanctuary': { alt: 'Eine Felsnische am Heiligtum, im Hintergrund Hügel', caption: 'Eine gemeißelte Nische mit Blick über die Hügel' },
    'tatul-excavation': { alt: 'Heller freigelegter Fels unter einem Schutzdach in Tatul', caption: 'Freigelegte Felswand unter einem Schutzdach' },
    'momchilgrad-square': { alt: 'Ein sonniger Platz in Momtschilgrad mit Gebäuden und Bäumen', caption: 'Der Hauptplatz von Momtschilgrad' },
    'momchilgrad-center': { alt: 'Der gepflasterte zentrale Platz von Momtschilgrad mit einem öffentlichen Gebäude am Ende', caption: 'Der gepflasterte zentrale Platz' },
    'kardzhali-museum': { alt: 'Das Regionale Geschichtsmuseum in Kardschali, ein Steingebäude mit zentralem Bogen', caption: 'Das Regionale Geschichtsmuseum in Kardschali' },
    'kardzhali-view': { alt: 'Blick über das Zentrum von Kardschali mit Wohnblocks und einem Park', caption: 'Das Zentrum von Kardschali aus der Vogelperspektive' },
    'kardzhali-reservoir': { alt: 'Der Stausee Kardschali windet sich zwischen bewaldeten Hügeln hindurch', caption: 'Der Stausee Kardschali an der Arda' },
    'perperikon-top': { alt: 'Der Felsgipfel von Perperikon über bewaldeten Hügeln', caption: 'Der Felsgipfel von Perperikon' },
    'perperikon-walls': { alt: 'Ein mittelalterlicher Steinturm in Perperikon vor einem Abendhimmel', caption: 'Ein mittelalterlicher Festungsturm in Perperikon bei Sonnenuntergang' },
    'perperikon-complex': { alt: 'Kahle Felsterrassen der archäologischen Anlage von Perperikon', caption: 'Die Felsterrassen der Anlage von Perperikon' },
    'stone-mushrooms': { alt: 'Eine pilzförmige Felsformation auf hellem Untergrund', caption: 'Eine pilzförmige Felsformation bei Beli Plast' },
    'stone-mushrooms-dusk': { alt: 'Pilzförmige Felsen als Silhouette gegen den Abendhimmel', caption: 'Die Steinpilze in der Abenddämmerung' },
    'studen-kladenets-dam': { alt: 'Eine Staumauer aus Beton, unten fließt Wasser aus', caption: 'Die Staumauer bei Studen Kladenez' },
  },
  footer: {
    tagline: 'Eine Informationsseite über das Dorf Nanovitsa in der Gemeinde Momtschilgrad, Oblast Kardschali, Bulgarien – und die Orte der Umgebung.',
    sourcesTitle: 'Quellen',
    photosTitle: 'Fotos und Karten',
    photosText: 'Die Fotografien stammen von Wikimedia Commons und werden unter Creative-Commons-Lizenzen oder gemeinfrei verwendet; Urheber und Lizenz sind unter jedem Foto angegeben. Kartendaten © OpenStreetMap-Mitwirkende. Die Entfernungen sind Luftlinien-Schätzungen anhand veröffentlichter Koordinaten.',
    disclaimer: 'Die Angaben wurden aus den oben genannten öffentlichen Quellen zusammengestellt und können sich ändern; bitte vor einer Reise überprüfen.',
  },
  common: {
    skip: 'Zum Inhalt springen',
    menuOpen: 'Menü',
    menuClose: 'Schließen',
    backToTop: 'Nach oben',
    showDetails: 'Details anzeigen',
    hideDetails: 'Details ausblenden',
    readGuide: 'Zum vollständigen Führer →',
    enlargePrefix: 'Foto vergrößern:',
    showPhotoPrefix: 'Foto anzeigen:',
    zoomHint: 'Vergrößern',
    photoViewer: 'Fotoansicht',
    closeViewer: 'Fotoansicht schließen',
    previousPhoto: 'Vorheriges Foto',
    nextPhoto: 'Nächstes Foto',
    filterPlacesAria: 'Orte nach Art filtern',
    filterPhotosAria: 'Fotos nach Ort filtern',
    filterTimelineAria: 'Zeitleiste nach Ort filtern',
    areasTablistAria: 'Zu erkundende Orte',
    straightLineTitle: 'Luftlinie ab Nanovitsa',
    language: 'Sprache',
    directions: ['N', 'NO', 'O', 'SO', 'S', 'SW', 'W', 'NW'],
  },
  news: {
    kicker: '05 · Neuigkeiten',
    title: 'Neuigkeiten der Gemeinde Momtschilgrad',
    lead: 'Aktuelle Schlagzeilen der Gemeinde, die für Nanovitsa zuständig ist, mit direkter Verlinkung zu den Originalartikeln auf der Website der Gemeinde.',
    readMore: 'Auf momchilgrad.bg lesen',
    viewAll: 'Alle Neuigkeiten auf momchilgrad.bg →',
    updated: 'Aktualisiert',
    sourceNote: 'Nur Überschriften und Daten – den vollständigen Artikel finden Sie über den Link auf der Website der Gemeinde. Nanovitsa.com ist eine unabhängige Informationsseite und steht in keiner Verbindung zur Gemeindeverwaltung.',
    untranslatedNote: 'Noch nicht übersetzt – zeigt die ursprüngliche bulgarische Überschrift.',
  },
}
